class player {
    constructor(playDom) {
        this.playDom = playDom;
        // console.log($(playDom))
        const width = this.playDom.clientWidth * 2;
        const height = this.playDom.clientHeight * 2;
        this.canvas = document.createElement('canvas');
        this.canvas.width = width;
        this.canvas.height = height;
        this.canvas.style.width = "100%";
        this.canvas.style.height = "100%";
        this.ctx = this.canvas.getContext("2d");
        this.isPaused = true;
        this.rederPlay = false;
        this.shouldLoop = playDom.attributes.loop ? (playDom.attributes.loop.value != "false") : false;
        this.frameIterator;
        this.videoTrack;
        this.sink;
        this.playerId;

        this.videoUrl = playDom.attributes.path.value;
        this.videoFps = playDom.attributes.fps.value;

        // 统一删除属性节点
        playDom.removeAttribute("loop");
        playDom.removeAttribute("path");
        playDom.removeAttribute("fps");
    }

    // 获取视频切片
    async getVideoFrames() {
        const { Input, MP4, UrlSource, VideoSampleSink } = Mediabunny;
        const input = new Input({
            formats: [MP4],
            source: new UrlSource(this.videoUrl),
        });

        this.videoTrack = await input.getPrimaryVideoTrack();
        if (!this.videoFps) {
            const stats = await this.videoTrack.computePacketStats(100);
            this.videoFps = Math.round(stats.averagePacketRate); // 获取真实的video帧率
        }
        const sink = new VideoSampleSink(this.videoTrack);

        this.playDom.innerHTML = "";
        this.playDom.appendChild(this.canvas);

        // 判断不是急着播放的话先渲染首帧
        if (!this.rederPlay) {
            let sample = await sink.getSample(0);
            if (!sample) {
                sample = await sink.getSample(1);
            }
            try {
                sample.draw(this.ctx, 0, 0, this.canvas.width, this.canvas.height);
            } finally {
                sample._data.close();
            }
        }
        this.rederPlay = false;
        return this.sink = sink;
    }

    // 实际切片播放
    async playVideoFrames() {
        const that = this;
        that.frameIterator = that.sink.samples();
        this.isPaused = false;

        const frameInterval = 1000 / that.videoFps;
        let lastFrameTime = performance.now();

        async function renderNextFrame() {
            const now = performance.now();
            const elapsed = now - lastFrameTime;

            if (!that.isPaused && elapsed >= frameInterval) {
                const { value: frame, done } = await that.frameIterator.next();

                if (done) {
                    if(that.endedEvent){
                        that.endedEvent();
                    }
                    if (that.shouldLoop) {
                        that.play(); // 自动重播
                    }
                    return;
                }
                that.videoFrame = frame._data;
                that.bitmap = await createImageBitmap(that.videoFrame);

                try {
                    that.ctx.clearRect(0, 0, that.canvas.width, that.canvas.height);
                    that.ctx.drawImage(that.bitmap, 0, 0, that.canvas.width, that.canvas.height);
                } finally {
                    that.videoFrame.close();
                    that.bitmap.close();
                }

                lastFrameTime = now;
            }

            that.playerId = requestAnimationFrame(renderNextFrame);
        }

        renderNextFrame();
    }

    // 暂停播放
    pause() {
        this.isPaused = true;
        this.videoFrame?.close();
        this.bitmap?.close();
    }

    play() {
        if (this.playDom.classList.contains('one-videoFrame')) {
            const that = this
            if (!that.sink) {
                if (that.rederPlay) return; //防止调用两次
                that.rederPlay = true;
                that.getVideoFrames().then(() => that.playVideoFrames())
            } else {
                if (that.isPaused) {
                    that.isPaused = false;
                } else {
                    that.videoFrame?.close();
                    that.bitmap?.close();
                    cancelAnimationFrame(that.playerId);
                    that.playVideoFrames(); // 重新开始播放
                }
            }
        }
    }
}